import { useAuth } from '@clerk/clerk-react'
import { Navigate, useLocation } from 'react-router-dom'
import { authUrlWithRedirect, locationToPath } from '@/lib/redirect'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isSignedIn, isLoaded } = useAuth()
  const location = useLocation()

  if (!isLoaded) {
    // Still loading auth state — show nothing to avoid flash
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-6 h-6 rounded-full border-2 border-[#9333EA] border-t-transparent animate-spin" />
      </div>
    )
  }

  if (!isSignedIn) {
    // Carry the FULL destination (path + query + hash) as a query param, not
    // just router state: a link
    // like /library/x?share=y must survive the sign-in → sign-up hop and a
    // refresh — which is also exactly how the website handoff reaches /resume
    // with its draft token. `state.from` remains as a fallback.
    const to = locationToPath(location)
    return <Navigate to={authUrlWithRedirect('/sign-in', to)} state={{ from: location }} replace />
  }

  return <>{children}</>
}
